import preloader from './lotties/preloader.json';
import loaderStars from './lotties/loader_stars.json';
import trashIcon from './lotties/trash_icon.json';
import editIcon from './lotties/edit_icon.json';
import infoIcon from './lotties/info_icon.json';
import searchIcon from './lotties/search_icon.json';
import heartIcon from './lotties/heart_icon.json';
import heartFullIcon from './lotties/heart_full_icon.json';
import bookmarkIcon from './lotties/bookmark_icon.json';
import bookmarkFullIcon from './lotties/bookmark_full_icon.json';
import thumbUpIcon from './lotties/thumb_up_icon.json';
import thumbDownIcon from './lotties/thumb_down_icon.json';

const lotties = {
  preloader,
  loaderStars,
  trashIcon,
  editIcon,
  infoIcon,
  searchIcon,
  heartIcon,
  heartFullIcon,
  bookmarkIcon,
  bookmarkFullIcon,
  thumbUpIcon,
  thumbDownIcon,
};

export default lotties;
